import { DatePicker, Form, Input, Radio, Select } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  createDropdownValues,
  createDropdownValuesNative,
} from "../../../Helpers/helperFunctions";
import { relationship } from "../../../pages/RpmModule/Constants/Menus/ConstantMenus";
import styles from "./index.module.scss";
import GenderPicker from "../CustomPickers/GenderPicker";

function AddMemberModal({ showModal, hidemodal, onSuccess,familyMembers }) {
  const [form] = Form.useForm();

  let handleFormFinish = (data) => {
    console.log(data);
    onSuccess(data);
    form.resetFields();
    hidemodal();
  };
  const handleChangeGender = (value) => {
    form.setFieldValue({ gender: value });
  };
  const onForceHide = () => {
    form.resetFields();
    hidemodal();
  };

  useEffect(() => {
    if (!showModal) {
      form.resetFields();
    }
  }, [showModal]);

  return (
    <Modal
      show={showModal}
      onHide={onForceHide}
      className={styles.add_newpatient_modal}
      backdrop="static"
    >
      <Modal.Body>
        <div className={styles.add_patient_form}>
          <div className={styles.close_modal_btn} onClick={hidemodal}>
            x
          </div>

          <Form form={form} onFinish={handleFormFinish}>


            
            <div className={styles.form_item}>
              <div className={styles.caption}>Patient Name</div>
              <div className={styles.form_input}>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "*Please enter patient name",
                    },
                  ]}
                >
                  <Input placeholder="Enter Patient Name" />
                </Form.Item>
              </div>
            </div>

            <div className={styles.form_item}>
              <div className={styles.caption}>Date of Birth</div>
              <div className={styles.form_input}>
                <Form.Item
                  name="dob"
                  rules={[
                    {
                      required: true,
                      message: "*Please select DOB",
                    },
                  ]}
                >
                  <DatePicker
                    // onKeyDown={allowOnlyNumericsOnDate}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    disabledDate={(current) =>
                      moment().add(0, "days") <= current
                    }
                    // value={formData?.dob || null}
                    onChange={(e) => {
                      //   handleChangeValues({ key: "dob", value: e });
                    }}
                    // className={`${styles.input}`}
                    style={{
                      width: "100% !important",
                    }}
                    format="DD-MM-YYYY"
                    placeholder="DD-MM-YYYY"
                  />
                </Form.Item>
              </div>
            </div>

            <div className={styles.form_item}>
              <div className={styles.caption}>Gender</div>
              <div className={styles.form_input}>
                <Form.Item
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: "*Please select gender",
                    },
                  ]}
                >
                  {/* <Radio.Group onChange={(e) => {}}>
                    <Radio value={"Male"}>Male</Radio>

                    <Radio value={"Female"}>Female</Radio>

                    <Radio value={"Other"}>Other</Radio>
                  </Radio.Group> */}
                  <GenderPicker onChange={handleChangeGender} />
                </Form.Item>
              </div>
            </div>

            <div className={styles.form_item}>
              <div className={styles.caption}>Relationship</div>
              <div className={styles.form_input}>
                <Form.Item
                  name="relationship"
                  rules={[
                    {
                      required: true,
                      message: "*Please select relationship",
                    },
                  ]}
                >
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    dropdownStyle={{ zIndex: "100" }}
                    options={createDropdownValuesNative(relationship)}
                    placeholder="Select Relationship"
                  />
                </Form.Item>
              </div>
            </div>

            <Button type="submit" onClick={() => {}}>
              Submit
            </Button>
          </Form>
        </div>
      </Modal.Body>

      {/* <div onClick={hidemodal} className={Style.not_emergency_back}>Not an emergency</div> */}
    </Modal>
  );
}

export default AddMemberModal;
